// components/QuizArticle.js
import React from "react";
import "../../styles/RealFakeArticle.css";

// QuizArticle component displays a news-style layout for each quiz item.
// Includes headline, summary, optional tip, and an image.
// If quiz data is missing, shows an error message.

const QuizArticle = ({ quiz, showTip, setShowTip }) => {
  // Handle missing quiz data
  if (!quiz) {
    return (
      <div className="quiz-box newspaper-style-box">
        <p className="error-message">Error: quiz data is unavailable.</p>
      </div>
    );
  }

  return (
    <div className="quiz-box newspaper-style-box">
      {/* News-style header */}
      <div className="news-header">BREAKING NEWS</div>
      <hr className="news-line" />

      {/* Quiz headline */}
      <h2 className="headline1">{quiz.headline}</h2>
      <hr className="news-line" />

      {/* Layout: summary (left) + image (right) */}
      <div className="news-inner-layout">
        {/* Summary text and tip toggle */}
        <div className="news-text">
          <p className="summary">{quiz.summary}</p>
          <div className="tip-row">
            {/* Tip toggle icon */}
            <span
              className="tip-toggle"
              onClick={() => setShowTip(!showTip)}
              title="Click to reveal tip"
            >
              💡
            </span>
            {/* Tip content (conditionally shown) */}
            {showTip && <span className="inline-tip">{quiz.tip}</span>}
          </div>
        </div>

        {/* Quiz image with credit */}
        <div className="news-image">
          <img src={quiz.image_url} alt="quiz" className="quiz-image-remote" />
          <div className="photo-credit">Photo by Wikimedia Commons</div>
        </div>
      </div>
    </div>
  );
};

export default QuizArticle;
